import React, { useEffect, useState } from "react"
import ModalContainer from "../../components/ModalContainer/ModalContainer"
import { useEvent } from "../../context/EventContext"
import FullLoader from "../../components/Loaders/FullLoader"
import DashboardNavbar from "../../components/Navbar/DashboardNavbar"
import { getProducts, updateRegistries } from "../../utils/ApiRequests"
import { Link } from "react-router-dom"
import RegistryItemPreview from "../../components/RegistryItemPreview/RegistryItemPreview"
import { useToasts } from "react-toast-notifications"
import ProgressBar from "../../components/ProgressBar/ProgressBar"
import {
  AiFillCaretLeft,
  AiOutlineCaretLeft,
  AiOutlineCaretRight
} from "react-icons/ai"

const EventPage3 = () => {
  const { currentRegistry } = useEvent()
  const { addToast } = useToasts()
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(true)
  const [products, setProducts] = useState()
  const [selectedProducts, setSelectedProducts] = useState([])
  const [page, setPage] = useState(1)

  if (page < 1) {
    setPage(1)
  }

  useEffect(() => {
    setLoading(true)
    getProducts(page)
      .then(res => {
        setProducts(res.data.data)
        setLoading(false)
      })
      .catch(err => {
        setLoading(true)
      })
  }, [page])

  const addItem = e => {
    e.preventDefault()
    setLoading(true)
    updateRegistries(currentRegistry, {
      products: selectedProducts
    })
      .then(res => {
        setLoading(false)
        setShowModal(true)
      })
      .catch(err => {
        setLoading(false)
        console.log(err.res)
        addToast("Please check your internet connection", {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  console.log(products)
  return (
    <div className="relative min-h-screen">
      {showModal && (
        <ModalContainer>
          <div className=" py-8 px-10 bg-sbg-white max-w-4xl">
            <p className="mb-5">Your registry has been created successfully</p>
            <Link
              to="/dashboard"
              className="mx-auto block bg-sbg-light-green px-16 py-3 text-center text-white rounded-md focus:outline-none"
            >
              Go to Dashboard
            </Link>
          </div>
        </ModalContainer>
      )}

      {loading && <FullLoader />}

      <DashboardNavbar />

      <form
        className="global-container pt-24 mx-auto relative z-10"
        onSubmit={e => addItem(e)}
      >
        <ProgressBar selected={3} />

        <h5 className="font-bold text-2xl text-grey my-10 medium:text-center">
          Publish
        </h5>

        {/* <DashboardItems /> */}

        <div className="grid grid-flow-row-dense w-full grid-cols-item gap-10 justify-between">
          {products?.products?.map(product => (
            <RegistryItemPreview
              img={product?.images[0]}
              key={product?._id}
              name={product.name}
              addToItems={setSelectedProducts}
              items={selectedProducts}
              id={product._id}
            />
          ))}
        </div>

        <div className="w-32 mx-auto text-center my-3 py-5 flex items-center">
          <AiFillCaretLeft
            className=" text-xl mr-2"
            onClick={() => setPage(page - 1)}
          />
          <button
            onClick={e => {
              setPage(page - 1)
              e.preventDefault()
            }}
            className="mr-2"
          >
            {page}
          </button>

          {products?.totalPage !== page && (
            <button
              onClick={e => {
                setPage(page + 1)
                e.preventDefault()
              }}
              className="ml-2"
            >
              {page + 1}
            </button>
          )}

          <AiOutlineCaretRight
            className="text-xl ml-2"
            onClick={() => setPage(page + 1)}
          />
        </div>
        <button
          className="my-6 mx-auto block bg-sbg-light-green px-10 py-3 text-center text-white rounded-md focus:outline-none"
          type="submit"
        >
          Publish Registry
        </button>
      </form>
    </div>
  )
}

export default EventPage3
